import React, { ReactNode, useEffect } from 'react';

import { useCommand } from '@apigrowfinance/pbolt-command-search';
import { usePermission } from '@apigrowfinance/pbolt-permission-provider';
import { RiArrowRightUpLine } from 'react-icons/ri';
import { useIntl } from 'react-intl';

import { useAccount } from '@contexts/AccountProvider';
import messages from '@messages/commands';
import getEnumTranslation from '@utils/getEnumTranslation';

export type CommandSearchProps = {
    children: ReactNode;
};

const CommandSearch = ({ children }: CommandSearchProps) => {
    const { addCommands, removeCommands } = useCommand();
    const { account, isLoading } = useAccount();
    const { isAllowedTo } = usePermission();
    const { formatMessage, locale } = useIntl();

    const getTranslation = (id: string) => {
        return getEnumTranslation(id, {
            messages,
            formatMessage,
        }) as string;
    };

    const commands = [
        ...(isAllowedTo('edit.accountStatus')
            ? [
                  {
                      id: 'accountStatus',
                      label: getTranslation('changeAccountStatus'),
                      icon: <RiArrowRightUpLine />,
                      action: `/accounts/${account?.account_id}/overview?changeStatus=true`,
                      category: 'ACTION',
                  },
              ]
            : []),
        {
            id: 'viewLimits',
            label: getTranslation('viewLimits'),
            icon: <RiArrowRightUpLine />,
            action: `/accounts/${account?.account_id}/customers/${account?.customer_id}/limits`,
            category: 'ACTION',
        },
    ];

    // Add commands and remount when locale changes
    useEffect(() => {
        if (!isLoading) {
            addCommands(commands);

            return () => {
                removeCommands(commands.map((command) => command.id));
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locale, isLoading]);

    return <>{children}</>;
};

export default CommandSearch;
